"use client";

import i18next from "i18next";
import { useTranslation as useTranslationOrg } from "react-i18next";
import { initReactI18next } from "react-i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { getOptions } from "./settings";
import { useState } from "react";

// Initialize i18next for client-side
i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`./locales/${language}/${namespace}.json`),
    ),
  )
  .init({
    ...getOptions(),
    detection: {
      order: ["navigator", "htmlTag", "cookie"],
      lookupCookie: "i18next",
      caches: ["cookie"],
      cookieMinutes: 60 * 24 * 30, // 30 days
    },
    lng: undefined,
  });

export function useClientTranslations(
  ns?: string,
  options: { keyPrefix?: string } = {},
) {
  const ret = useTranslationOrg(ns, options);
  return ret;
}

export function useDetector() {
  const [language] = useState(i18next.language);

  // useEffect(() => {
  //   const detector = new LanguageDetector();
  //   detector.init(i18next.options.detection);
  //   if (detector) {
  //     const languageDetected = detector.detect();
  //     if (languageDetected) {
  //       if (Array.isArray(languageDetected)) {
  //         setLanguage(languageDetected[0]);
  //       } else {
  //         setLanguage(languageDetected);
  //       }
  //     }
  //   }
  // }, [language]);

  return language;
}
